module.exports = __webpack_public_path__ + "img/chatkit-mcp.63973f5f.png";